import React, { useState } from 'react';
import { FilterList } from '@mui/icons-material';
import { Checkbox, DropdownMenu, PillButton, RadioGroup, Select, Stack, Text } from 'library/ui';

import { useUserContext } from 'UserContext';
import { STAFF, WORKED } from '../constants';

import type { FilterProps } from '../models';

export function Filters({
    formValues,
    handleChange,
}: {
    formValues: FilterProps;
    handleChange: (value: string | boolean, formKey: string) => void;
}) {
    const [open, setOpen] = useState(false);
    const { user } = useUserContext();

    const addresses = user?.address || [];

    const locationOptions = [
        { value: 'All Locations', key: '-1' },
        ...addresses.map((x) => ({
            value: x.business_location?.name
                ? `${x.business_location.name} — ${x.city}, ${x.state}`
                : `${x.street} ${x.city}, ${x.state} ${x.zip_code}`,
            key: x.id.toString(),
        })),
    ];

    const activeCount =
        (formValues.address !== '-1' ? 1 : 0) +
        (formValues.workerType !== WORKED ? 1 : 0) +
        (formValues.showPreferred ? 1 : 0);

    return (
        <DropdownMenu
            open={open}
            onClose={() => setOpen(false)}
            width={320}
            trigger={
                <PillButton
                    variant="secondary"
                    icon={<FilterList sx={{ fontSize: 18 }} />}
                    onClick={() => setOpen((prev) => !prev)}
                >
                    Filters{activeCount > 0 ? ` (${activeCount})` : ''}
                </PillButton>
            }
        >
            <Stack gap="lg" padding="md">
                <Stack gap="sm">
                    <Text weight="semibold">Location</Text>
                    <Select
                        value={formValues.address}
                        options={locationOptions}
                        onChange={(value) => handleChange(value, 'address')}
                        fullWidth
                    />
                </Stack>
                <Stack gap="sm">
                    <Text weight="semibold">Workers</Text>
                    <RadioGroup
                        value={formValues.workerType}
                        options={[
                            { value: WORKED, label: 'Worked at my center' },
                            { value: STAFF, label: 'Scheduled at my center' },
                        ]}
                        onChange={(value) => handleChange(value, 'workerType')}
                    />
                </Stack>
                <Checkbox
                    label="Preferred only"
                    checked={formValues.showPreferred}
                    onChange={(checked) => handleChange(checked, 'showPreferred')}
                />
            </Stack>
        </DropdownMenu>
    );
}
